import { call, put, takeLatest } from "redux-saga/effects";
import { onPostEarnPointError, onPostEarnPointSubmit, onPostEarnPointSuccess } from "../Store/Slices/earnPointSlice";
import { callEarnPointApi } from "../Context/earnPointApi";

function* PostEarnPoints({ payload }) {
  try {
    const postEarnPointResponse = yield call(callEarnPointApi, payload);
    if (postEarnPointResponse.responseCode === "200") {
      yield put(
        onPostEarnPointSuccess({
          postData: postEarnPointResponse?.response,
          message: postEarnPointResponse?.responseMessage,
          status_code: postEarnPointResponse?.responseCode,
        })
      );
    } else {
      yield put(
        onPostEarnPointError({
          data: postEarnPointResponse?.response,
          message: postEarnPointResponse?.responseMessage,
          status_code:postEarnPointResponse?.responseCode
        })
      );
    }
  } catch (error) {
    const message = error?.response?.data?.responseMessage || "Something went wrong";
    yield put(onPostEarnPointError({ data: [], message, status_code: 400 }));
  }
}
export default function* EarnPointSaga() {
  yield takeLatest(onPostEarnPointSubmit.type, PostEarnPoints);
}
